<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M12 10H0V1a1 1 0 0 1 1-1h5l6 6v4Z" opacity=".45" transform="translate(2)" fill="currentColor"/><path d="M12.001 6.003h-5a1 1 0 0 1-1-1v-5l6 6Z" transform="translate(2)" fill="currentColor"/><path d="M1.231 16.002h13.536A1.231 1.231 0 0 0 16 14.772v-4.769H8.124a.308.308 0 0 1-.211-.084L6 8.336a1.135 1.135 0 0 0-.844-.335L0 8.002v6.769a1.231 1.231 0 0 0 1.231 1.231Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering06',
});
</script>
